import CategoryPage from "@/pages/category/components/CategoryPage";
import { getArticlesByCategory } from "@/mocks/articles";

export default function XinyouManhuahua() {
  return (
    <CategoryPage
      categorySlug="xinyou-manhuahu"
      metaTitle="新游漫画化 - 游戏改编漫画抢先看 | 可游漫画网"
      metaDesc="可游漫画网新游漫画化栏目，第一时间发布游戏改编漫画企划与连载内容，新游漫画化动态、视觉图与剧情解读抢先看。"
      heading="新游漫画化"
      kicker="漫画抢先看"
      articles={getArticlesByCategory("xinyou-manhuahu")}
    />
  );
}